<template>
    <div>
        <section class="hero">
            <div class="hero__left">
                <div class="hero__container hero__container--big-margin">
                    <div class="hero__body">
                        <div class="hero__info">
                            <div class="benefit__tag benefit__tag--big-margin">{{ $lang('sections.memories.beta') }}
                            </div>
                            <h2 class="title title--m title--uppercase hero__title hero__title--w600"
                                v-html="$lang('sections.memories.history_1')">
                            </h2>
                            <div class="hero__text hero__text--w360" v-html="$lang('sections.memories.history_2')">
                            </div>
                            <div class="hero__links">
                                <a v-scroll-to="'#info'" @click="menu = false" @mouseover="moved = true"
                                    @mouseleave="moved = false"
                                    class="btn btn--big btn--main-bg hero__link hero__create">
                                    {{ $lang('sections.memories.details') }}
                                </a>
                                <router-link :to="{
                                    name: 'memories-feedback',
                                    params: {
                                        title: $lang('sections.memories.feedback_1'),
                                        description: $lang('sections.memories.feedback_2'),
                                        button: $lang('sections.memories.subscribe')
                                    }
                                }" class="link hero__link hero__examples">
                                    <span>{{ $lang('sections.memories.createPage') }}</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="hero__imgs hero__imgs--memories" itemscope
                            itemtype="https://schema.org/ImageObject">
                            <meta itemprop="name" :content="$lang('sections.memories.history_1')">
                            <meta itemprop="description" :content="$lang('sections.memories.history_2')">

                            <picture class="hero__img hero__img--alone-vert shadow__img">
                                <source media="(min-width: 1200px)" srcset="/assets/front/img/hero-memories.png">
                                <img src="/assets/front/img/hero-memories-mob.png"
                                    :alt="$lang('sections.memories.history_1')" itemprop="contentUrl">
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hero__right" itemscope itemtype="https://schema.org/ImageObject">
                <meta itemprop="name" :content="$lang('sections.memories.history_1')">
                <meta itemprop="description" :content="$lang('sections.memories.history_2')">

                <img class="hero__right-bg" src="/assets/front/img/hero-bg-mem.png"
                    :alt="$lang('sections.memories.history_1')" itemprop="contentUrl"
                    :class="{ 'hero__right-bg--move': moved }">
            </div>
        </section>

        <section class="info__memories container" id="info">
            <div class="info__block shadow">
                <div class="info__img" itemscope itemtype="https://schema.org/ImageObject">
                    <meta itemprop="name" :content="$lang('sections.memories.write_1')">
                    <meta itemprop="description" :content="$lang('sections.memories.write_2')">

                    <img src="/assets/front/img/info/info-1.png" :alt="$lang('sections.memories.write_1')"
                        itemprop="contentUrl">
                </div>
                <div class="info__content">
                    <svg class="info__img-icon info__img-icon--right">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-bookmarks"></use>
                    </svg>
                    <div class="title title--ms title--uppercase info__title">
                        {{ $lang('sections.memories.write_1') }}
                    </div>
                    <p class="info__desc">
                        {{ $lang('sections.memories.write_2') }}
                    </p>
                    <router-link :to="{
                        name: 'memories-feedback',
                        params: {
                            title: $lang('sections.memories.feedback_1'),
                            description: $lang('sections.memories.feedback_2'),
                            button: $lang('sections.memories.subscribe')
                        }
                    }" class="btn btn--main-bg btn--big info__btn">
                        <span>{{ $lang('sections.memories.updateEvent') }}</span>
                    </router-link>
                </div>
            </div>

            <div class="info__block info__block--reverse shadow" id="moments">
                <div class="info__content">
                    <svg class="info__img-icon info__img-icon--left">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-play"></use>
                    </svg>
                    <div class="title title--ms title--uppercase info__title"
                        v-html="$lang('sections.memories.comment_1')">
                    </div>

                    <p class="info__desc">
                        {{ $lang('sections.memories.comment_2') }}
                    </p>

                    <router-link :to="{
                        name: 'memories-feedback',
                        params: {
                            title: $lang('sections.memories.feedback_1'),
                            description: $lang('sections.memories.feedback_2'),
                            button: $lang('sections.memories.subscribe')
                        }
                    }" class="btn btn--main-bg btn--big info__btn">
                        <span>{{ $lang('sections.memories.updateEvent') }}</span>
                    </router-link>
                </div>
                <div class="info__img" itemscope itemtype="https://schema.org/ImageObject">
                    <meta itemprop="name" :content="$lang('sections.memories.comment_1')">
                    <meta itemprop="description" :content="$lang('sections.memories.comment_2')">

                    <img src="/assets/front/img/info/info-2.png" :alt="$lang('sections.memories.comment_1')"
                        itemprop="contentUrl">
                </div>
            </div>
        </section>

        <section class="info__banner">
            <div class="container info__banner-content">
                <img src="/assets/front/img/info/info__banner-bg.png" alt="img" class="info__bg info__banner-bg">
                <div itemscope itemtype="https://schema.org/ImageObject">
                    <meta itemprop="name" :content="$lang('sections.memories.history_3')">
                    <meta itemprop="description" :content="$lang('sections.memories.history_4')">

                    <picture class="info__banner-img shadow__img">
                        <source media="(min-width: 1200px)" srcset="/assets/front/img/info/info__banner-img.png">
                        <img src="/assets/front/img/info/info__banner-img-mob.png"
                            :alt="$lang('sections.memories.history_3')" itemprop="contentUrl">
                    </picture>
                </div>
                <div class="info__banner-text">
                    <div class="title title--sm title--uppercase title--white info__banner-title">
                        {{ $lang('sections.memories.history_3') }}
                    </div>
                    <p class="info__banner-desc">
                        {{ $lang('sections.memories.history_4') }}
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "MemoriesLanding",
    data() {
        return {
            moved: false
        }
    }
}
</script>

<style scoped></style>
